module.exports = __webpack_public_path__ + "static/media/icono_harina_am.ad6966ba.png";